import { render } from "./FormCheckBox.vue?vue&type=template&id=37c60418&ts=true"
import script from "./FormCheckBox.vue?vue&type=script&lang=ts"
export * from "./FormCheckBox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__